import React from 'react';
import Artistic from '../../images/home/wall.jpg';
import { motion } from "framer-motion";
import { MdArrowRightAlt } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import Fadeup from '../fadeup/Fadeup';

function  NewsBanner() {
    const navigate = useNavigate();
    return (
        <section className="sec_pd bg-dark news_bg">
            <div className="rounded p-5">
                    <div className="row g-4 align-items-end">
                    <div className="row g-4 align-items-start justify-content-start">
                        <div className="col-12 col-md-12 d-flex flex-column align-items-md-start text-md-start text-start text-start text-container-mobile">
                            <Fadeup delay={0.3}>
                            <h5 className="!text-black  pb-2 fs_40" style={{color:"black !important"}}>News</h5>
                            <h4 className='text-white'>Explore  Anachronistic Auction House Art’s latest collaborations, partnerships and talks</h4>
                            </Fadeup>
                        </div>
                        </div>
                    </div>
                </div>
        </section>
    );
}

export default NewsBanner;
